import translate from "@insite/client-framework/Translate";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import Typography, { TypographyProps } from "@insite/mobius/Typography";
import { checkoutInfoGridProps, checkoutInfoProps, checkoutSubtitleProps } from "@store/theme/common/props/checkout";
import getWidgetComponent from "@store/utilities/getWidgetComponent";
import React, { FC } from "react";

const BillingAddress = getWidgetComponent("OrderDetails/OrderDetailsBillingAddress");

interface Props {}

export interface StoreOrderBillingInformationStyles {
    gridContainer?: GridContainerProps;
    addressGridItem?: GridItemProps;
    title?: TypographyProps;
}

export const storeOrderBillingInformationStyles: StoreOrderBillingInformationStyles = {
    gridContainer: checkoutInfoGridProps.container,
    addressGridItem: checkoutInfoGridProps.item,
    title: checkoutSubtitleProps,
};

const styles = storeOrderBillingInformationStyles;

const StoreOrderBillingInformation: FC<Props> = () => {
    return (
        <>
            <Typography {...styles.title}>{translate("Billing Information")}</Typography>
            <GridContainer {...styles.gridContainer}>
                <GridItem {...styles.addressGridItem}>
                    <BillingAddress />
                </GridItem>
            </GridContainer>
        </>
    );
};

export default StoreOrderBillingInformation;
